import * as types from '../types.js';

export default async function(records)
{
	return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; }
			.view td:nth-child(4)	{ text-align: right; }
			.view td:nth-child(5)	{ text-align: left; max-width: 14rem; }
			.view td:nth-child(6)	{ text-align: left; max-width: 12rem; }
			.view td:nth-child(7)	{ text-align: center; }
			.view td:nth-child(8)	{ text-align: left; max-width: 8rem; }
			.view td:nth-child(9)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(10)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(11)	{ text-align: left; }
			.view td:nth-child(12)	{ text-align: right; }
			.view td:nth-child(13)	{ text-align: right; }
			.view td:nth-child(14)	{ text-align: right; }
			.view td:nth-child(15)	{ text-align: right; }
			.view td:nth-child(16)	{ text-align: left; }
			.view td:nth-child(17)	{ text-align: left; }
			.view td:nth-child(18),
			.view td:nth-child(19),
			.view td:nth-child(20)	{ text-align: left; max-width: 14rem; }
			.view td:nth-child(21),
			.view td:nth-child(22)	{ text-align: left; max-width: 14rem; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar seleções"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Saída</th>
					<th data-index="4" data-visible="${this.visible[2]}">Pedido</th>
					<th data-index="15" data-visible="${this.visible[3]}">Programa</th>
					<th data-index="16" data-visible="${this.visible[4]}">Referência</th>
					<th data-index="20" data-visible="${this.visible[5]}">Cliente</th>
					<th data-index="25" data-visible="${this.visible[6]}">Rota</th>
					<th data-index="21" data-visible="${this.visible[7]}">Transportador</th>
					<th data-index="3" data-visible="${this.visible[8]}">Origem</th>
					<th data-index="5" data-visible="${this.visible[9]}">Criação</th>
					<th data-index="6" data-visible="${this.visible[10]}">Expedição</th>
					<th data-index="7" data-visible="${this.visible[11]}">Remetente</th>
					<th data-index="8" data-visible="${this.visible[12]}">Armazém</th>
					<th data-index="9" data-visible="${this.visible[13]}">Tipo Volumes</th>
					<th data-index="10" data-visible="${this.visible[14]}">Volumes</th>
					<th data-index="11" data-visible="${this.visible[15]}">Peso</th>
					<th data-index="12" data-visible="${this.visible[16]}">Custo Total</th>
					<th data-index="13" data-visible="${this.visible[17]}">Preço Total</th>
					<th data-index="14" data-visible="${this.visible[18]}">Status</th>
					<th data-index="18" data-visible="${this.visible[19]}">SKU (itens)</th>
					<th data-index="19" data-visible="${this.visible[20]}">Produto (itens)</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async record => 
				`<tr data-id='${JSON.stringify([record.company_id, record.id])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([record.company_id, record.id]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick')}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${record.order_id}</td>
					<td data-visible='${this.visible[3]}'>${await this.key('programs', record.program_id ? [record.company_id, record.program_id] : null, 'name') || ''}</td>
					<td data-visible='${this.visible[4]}'>${record.reference || ''}</td>
					<td data-visible='${this.visible[5]}'>${await this.key('customers', record.customer_id ? [record.company_id, record.customer_id] : null, 'nick') || ''}</td>
					<td data-visible='${this.visible[6]}' title="${record.route_name || ''}">${record.route_code || '-'}</td>
					<td data-visible='${this.visible[7]}'>${await this.key('carriers', record.carrier_id ? [record.company_id, record.carrier_id] : null, 'nick') || ''}</td>
					<td data-visible='${this.visible[8]}'>${this.option(types.opt_order_type(), record.order_type)}</td>
					<td data-visible='${this.visible[9]}'>${this.format(types.datetime(), record.created_on)}</td>
					<td data-visible='${this.visible[10]}'>${this.format(types.datetime(), record.expedited_on) || ''}</td>
					<td data-visible='${this.visible[11]}'>${await this.key('companies', record.warehouse_company_id, 'nick') || ''}</td>
					<td data-visible='${this.visible[12]}'>${await this.key('warehouses', [record.warehouse_company_id, record.warehouse_id]) || ''}</td>
					<td data-visible='${this.visible[13]}'>${this.option(types.opt_volume_type(), record.volume_type) || ''}</td>
					<td data-visible='${this.visible[14]}'>${record.volumes ? this.format(types.number(0), record.volumes) : ''}</td>
					<td data-visible='${this.visible[15]}'>${record.weight ? this.format(types.number(3), record.weight) : ''}</td>
					<td data-visible='${this.visible[16]}'>${record.total_cost ? this.format(types.number(2), record.total_cost) : ''}</td>
					<td data-visible='${this.visible[17]}'>${record.total_price ? this.format(types.number(2), record.total_price) : ''}</td>
					<td data-visible='${this.visible[18]}'>${this.option(types.opt_output_status(), record.status) || ''}</td>
					<td data-visible='${this.visible[19]}'>${record.lines_sku_summary || ''}</td>
					<td data-visible='${this.visible[20]}'>${record.lines_product_summary || ''}</td>
				</tr>`
				))).join('') +
			`
			</tbody>
		</table>
	`;
};

